module.exports = __webpack_public_path__ + "static/img/banner-word.d4d093b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/img/banner-word.png
// module id = 87By
// module chunks = 97